<div class="row">
  <div class="col">
    <p *ngIf="coApplicant" class="text-primary mt-2">
      Halfway done! You&rsquo;re making great progress.
    </p>
    <h2>Applicant Employer</h2>
  </div>
</div>

<form [formGroup]="employerFormGroup">
  <app-employer-group
    [primaryFormGroup]="employerFormGroup"
    [secondaryFormGroup]="otherIncomeFormGroup"
    [primaryControls]="employerFormGroup.controls"
    [secondaryControls]="otherIncomeFormGroup.controls"
  ></app-employer-group>
</form>

<hr class="hr-style" />

<div class="row my-5">
  <div class="col-12 col-lg-6">
    <button type="button" class="btn btn-primary" (click)="onNext()">
      Continue to {{ coApplicant ? 'Co-Applicant Info' : 'Finish & Submit' }}
      <i class="bi bi-chevron-right"></i>
    </button>

    <app-validation-text
      [show]="
        isDirtyAndMissingRequiredFields ||
        isOtherIncomeDirtyAndMissingRequiredFields
      "
    ></app-validation-text>
  </div>
  <div class="col-12 col-lg-6">
    <div class="mt-3 mt-lg-0 text-center text-md-start text-lg-end">
      <button class="btn btn-link" (click)="onFinishByPhone()">
        <small> Finish Application by Phone </small>
      </button>
    </div>
  </div>
</div>
